import type { RefOrGetter } from "ls/common/types";
import type { UserProfile } from "./utils";
import { computed, toValue } from "vue";
import { getUserName } from "./utils";

export function getDisplayName(profile: Pick<UserProfile, "email" | "nickname">): string {
  return getUserName(profile.email, profile.nickname);
}

export function useDisplayName(profile: RefOrGetter<UserProfile>) {
  const displayName = computed(() => getDisplayName(toValue(profile)));
  return displayName;
}
